import { forwardRef } from 'react';
import type {
  AnyColorFormat,
  ColorPickerResult,
  ColorPickerValue,
  ColorPickerTypes,
} from 'antd-colorpicker';
import { StyledColorPicker } from './ColorPicker.styles';

type Props = {
  value?: string;
  onChange?: (v: string) => void;
  onColorResult?: (color: ColorPickerResult) => AnyColorFormat;
  popup?: boolean;
  popoverProps?: any;
  blockStyles?: any;
  picker?: ColorPickerTypes;
  colors?: string[];
};

const ColorPicker = forwardRef<any, Props>(
  (
    { onColorResult = (c: ColorPickerResult): ColorPickerValue => c.hex, ...props }: Props,
    ref: any,
  ) => {
    return <StyledColorPicker onColorResult={onColorResult} {...props} innerRef={ref} />;
  },
);

export { ColorPicker };
